import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import { CreateEmployeeTransitPassPayload } from './transitPassTypes'

const getEmployeeTransitPasses = (): Promise<AxiosResponse> => {
  return Request.get('/mobile/core/transit_passes/')
}

const createEmployeeTransitPass = (
  payload: CreateEmployeeTransitPassPayload
): Promise<AxiosResponse> => {
  return Request.post('/mobile/core/transit_passes/', payload)
}

const TransitPassService = {
  getEmployeeTransitPasses,
  createEmployeeTransitPass,
}

export default TransitPassService
